import cn from 'classnames';

import { Menu } from '../../components/Menu/Menu';
import { togglePage } from '../../helpers/togglePage';
import { SIX_IN_TIX_LIST } from '../../constants/sixInTixList';
import {
  FC,
  MutableRefObject,
  RefObject,
  useEffect,
  useRef,
  useState,
} from 'react';

import { toggleMenu } from '../../helpers/toggleMenu';
import { Sections } from '../../types/Sections';
import { isSixInHash } from '../../helpers/isSixInHash';
import { getTranslation } from '../../constants/translations';
import Slider from 'react-slick';
import { MenuItems } from '../../types/MenuItems';
import { getDefinedRegion } from '../../helpers/getRegion';

import './Footer.scss';

type Props = {
  sliderRef?: RefObject<Slider>;
};

export const Footer: FC<Props> = ({ sliderRef }) => {
  const [bottomValue, setBottomValue] = useState('0');
  const [isFooterOpen, setFooterOpen] = useState(false);

  const footer = useRef() as MutableRefObject<HTMLElement>;
  const { hash } = window.location;

  const t = getTranslation();
  const domen = getDefinedRegion();

  const toggleFooter = () => {
    footer.current.classList.toggle('footer--shown');
    setFooterOpen((prev) => !prev);
  };

  useEffect(() => {
    if (isFooterOpen) {
      toggleMenu('hide');
    } else {
      toggleMenu('show');
    }
  }, [isFooterOpen]);

  useEffect(() => {
    if (isFooterOpen) {
      toggleFooter();
    }

    /* document.addEventListener('click', (e) => {
      const _overlapped = document.elementsFromPoint(
        e.pageX,
        e.pageY - window.scrollY,
      );

      console.log(_overlapped);
    }); */
  }, [window.location.hash]);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      footer.current.classList.remove('footer--shown');
      setFooterOpen(false);

      if (window.location.hash !== '#' + Sections.SIXINTIX) {
        toggleMenu('show');
      }
    });

    const menuWrappersList =
      document.getElementsByClassName('menu-page-wrapper');

    for (const menu of menuWrappersList) {
      menu.addEventListener('scroll', () => {
        footer.current.classList.remove('footer--shown');
      });
    }

    const sixPagesList = document.getElementsByClassName('six-page-wrapper');

    for (const page of sixPagesList) {
      page.addEventListener('scroll', () => {
        footer.current.classList.remove('footer--shown');
      });
    }

    if (footer.current) {
      window.setTimeout(() => {
        setBottomValue(-footer.current.clientHeight - 35 + 'px');
      }, 500);

      if (window.screen.width < 990) {
        window.setTimeout(() => {
          setBottomValue(-footer.current.clientHeight + 30 + 'px');
        }, 4450);
      } else {
        window.setTimeout(() => {
          setBottomValue(-footer.current.clientHeight + 'px');
        }, 4450);
      }
    }
  }, []);

  return (
    <footer
      className="footer"
      ref={footer}
      style={{
        bottom: bottomValue,
      }}
    >
      <div
        className={cn('footer__toper', {
          'footer__toper--shown': isFooterOpen,
          'footer__toper--down':
            (isSixInHash() && !isFooterOpen) ||
            (hash.includes(Sections.SIXINTIX) && !isFooterOpen),
        })}
      >
        <button className="footer__toggle-button" onClick={toggleFooter}>
          {isFooterOpen ? t.COMMON.back : t.COMMON.show}
        </button>
      </div>

      <div className="footer__container _container">
        <div className="footer__info-section">
          <div className="footer__info-block">
            <h4 className="footer__info-title">Menu</h4>
            {t.REGISTER['I want to start']}
            <ul className="footer__info-subblock footer__info-subblock--menu">
              {SIX_IN_TIX_LIST.map((item) => (
                <li key={item}>
                  <button
                    className="footer__link-button"
                    onClick={() => togglePage(`#${item}`)}
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer__info-block">
            <h4 className="footer__info-title">{t.COMMON.support}</h4>
            <div className="footer__info-subblock">
              <a href={t.COMMON.termsLink} target="_blank" rel="noreferrer">
                {t.COMMON['Terms and Conditions']}
              </a>
              <a
                href={t.COMMON.privacyPolicyLink}
                target="_blank"
                rel="noreferrer"
              >
                {t.COMMON.privacyPolicy}
              </a>
              <a href={t.COMMON.cookieLink} target="_blank" rel="noreferrer">
                {t.COMMON.cookie}
              </a>
            </div>

            <div className="footer__info-subblock">
              <a href={`mailto:support@sixtix.${domen}`}>
                support@sixtix.{domen}
              </a>
            </div>

            <div className="footer__info-subblock">
              <a href={'#' + MenuItems.LOST}>{t.LOST_TICKET['Lost ticket']}?</a>
            </div>
          </div>

          <div className="footer__info-block">
            <h4 className="footer__info-title">SixTix NL</h4>
            <div className="footer__info-subblock">
              {t.FOOTER.address.map((address) => (
                <p key={address}>{address}</p>
              ))}
            </div>

            <div className="footer__info-subblock">
              {t.FOOTER.details.map((detail) => (
                <p key={detail}>{detail}</p>
              ))}
              <a href={`mailto:admin@sixtix.${domen}`}>admin@sixtix.{domen}</a>
            </div>
          </div>

          {/* <div className="footer__info-block">
            <h4 className="footer__info-title">Bedrijf</h4>
            <div className="footer__info-subblock">
              <a href="http://">Agenda</a>
              <a href="http://">Oorsprong</a>
              <a href="http://">Kan je ons helpen?</a>
              <a href="http://">Affiliate worden</a>
              <a href="http://">Stamboom</a>
              <a href="http://">Siteoverzicht</a>
            </div>

            <div className="footer__info-subblock">
              <a href="mailto:hallo@sixtix.nl">hallo@sixtix.nl</a>
            </div>
          </div> */}
        </div>
      </div>

      <Menu position="absolute" customClassName="footer__menu" />
      {(isSixInHash() || window.location.hash.includes(Sections.SIXINTIX)) && (
        <Menu
          position="absolute"
          sliderRef={sliderRef}
          customClassName="menu--horizontal"
        />
      )}
    </footer>
  );
};
